import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import type { Observable } from 'rxjs'
import { catchError, of } from 'rxjs'

import { environment } from '../../../environments/environment'
import type { FilterType } from '../../types/types'

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  private readonly http = inject(HttpClient)

  private readonly apiUrl = environment.apiUrl

  getTypes(): Observable<FilterType[]> {
    return this.http.get<FilterType[]>(`${this.apiUrl}/filters/types`).pipe(
      catchError((error: unknown) => {
        console.error('Error fetching filter types:', error)
        // Provide fallback filter types when the API fails
        return of([
          { id: '1', name: 'Article', selected: false },
          { id: '2', name: 'Interview', selected: false },
          { id: '3', name: 'Review', selected: false },
        ])
      })
    )
  }
}
